import {Avatar, Card, Flex, List, Rate, Typography} from "antd";
import React from "react";
import {useTranslations} from "next-intl";
import {Review} from "@/src/entities/review";
import {UserOutlined} from "@ant-design/icons";
import {ThemeService} from "@/src/services/theme";

type Props = {
    reviewList: Review[]
}

const ReviewComponent = (props: Props) => {

    const localization = useTranslations('review');
    const themeColors = ThemeService.getThemeColors()

    return (
        <div style={{padding: 24}}>
            <Flex vertical gap={16} justify={"center"} align={"center"} style={{margin: "60px 0 40px 0", padding: "0 24px", textAlign: "center"}}>
                <Typography.Title level={2} className={"sectionTitle"}>{localization("title")}</Typography.Title>
                <Typography.Text  style={{fontSize: 16, color: "#444"}}>{localization("text")}</Typography.Text>
            </Flex>

            <List
                itemLayout="horizontal"
                dataSource={props.reviewList}
                renderItem={(item, index) => {
                    let title = <Flex vertical={false} gap={16} align={"center"} style={{marginBottom: 10}}>
                        <Typography.Title level={5} style={{margin: 0}}>{item.name}</Typography.Title>
                        <Rate value={item.rate} allowHalf={true} style={{fontSize: 16}}/>
                    </Flex>
                    return (
                        <Card style={{marginBottom: 20}}>
                            <List.Item>
                                <List.Item.Meta
                                    avatar={<Avatar style={{ backgroundColor: index % 2 === 0 ? themeColors.menuBarColor : themeColors.secondary }} icon={<UserOutlined />} />}
                                    title={title}
                                    description={item.review}
                                />
                            </List.Item>
                        </Card>

                    )
                }

                }
            />        </div>
    )
}

export default ReviewComponent